import React, { memo } from 'react';
import { Dialog, DialogContent, DialogTitle } from 'investira.react.components';
import { useRelatorioContext } from '../../../contexts/RelatorioContext';
import DurationParams from '../_params/DurationParams';
import EnquadramentoParams from '../_params/EnquadramentoParams';
import VarParams from '../_params/VarParams';
import StressTestParams from '../_params/StressTestParams';
import ConferenciaCustodianteParams from '../_params/ConferenciaCustodianteParams';

const ReportParamsDialog = memo(props => {
  const { carteiras, portfolios, output, lastOutput } = props;
  const { state } = useRelatorioContext();

  const OUTPUTS = {
    duration: DurationParams,
    enquadramento: EnquadramentoParams,
    var: VarParams,
    stresstest: StressTestParams,
    conferenciacustodiante: ConferenciaCustodianteParams
  };

  const OutputParamsComponent = OUTPUTS[output];

  return (
    <Dialog open={state.isDialogOpen} maxWidth="sm">
      <DialogTitle>Novo Relatório</DialogTitle>
      <DialogContent>
        <OutputParamsComponent
          carteiras={carteiras}
          portfolios={portfolios}
          lastOutput={lastOutput}
        />
      </DialogContent>
    </Dialog>
  );
});

export default ReportParamsDialog;
